import { dateAndTimeConverter } from "../../Utils/constants";
import Button from "../../Components/Button/Button";
import {
  ApprovalPendingIcon,
  OfflineIcon,
  WarningIcon
} from "../../Assets/assets";
import { useEffect } from "react";
import { isValidObject } from "../../Services/validators";

export default function ComparisonStatus(props) {
  useEffect(() => {
    if (!isValidObject(props.faceComparisonData)) {
      props.navigate(-1);
    }
    // eslint-disable-next-line
  }, [props.faceComparisonData]);

  return (
    <>
      {window.location.pathname.includes("/success") && <Success {...props} />}
      {window.location.pathname.includes("/failed") && <Failed {...props} />}
      {window.location.pathname.includes("/denied") && (
        <ApprovalDenied {...props} />
      )}
      {window.location.pathname.includes("/offline") && <Offline {...props} />}
      {window.location.pathname.includes("/pending") && (
        <PendingApproval {...props} />
      )}
    </>
  );
}

const Success = (props) => {
  return (
    <div className="inherit-parent-height inherit-parent-width padding-large display-flex flex-direction-column flex-justify-content-space-between">
      <div
        style={{ height: "calc(100% - 68px)" }}
        className="display-flex flex-direction-column flex-align-items-center flex-justify-content-center"
      >
        <div className="wrapper padding-bottom-larger">
          <svg className="check_mark" viewBox="0 0 52 52">
            <circle
              className="check_mark_circle"
              cx="26"
              cy="26"
              r="25"
              fill="none"
            />
            <path
              className="check_mark_check"
              fill="none"
              d="M14.1 27.2l7.1 7.2 16.7-16.8"
            />
          </svg>
        </div>

        <div className="font-size-medium  text-align-center ">
          PROFILE MATCHED!
        </div>
        <div className="font-size-small text-align-center padding-top-small font-color-tertiaryColor5">
          YOUR ATTENDANCE FOR THIS INTERVAL IS REGISTERED
        </div>

        <div className="padding-top-larger display-flex inherit-parent-width flex-align-items-center flex-justify-content-space-between">
          <div className="font-size-small text-align-center">
            CAPTURED IMAGE
            <div
              style={{
                width: "156px",
                height: "182px"
              }}
            >
              {props.faceComparisonData?.fileUrl ||
              props.faceComparisonData?.captured?.photo ? (
                <img
                  style={{
                    objectFit: "cover"
                  }}
                  className="inherit-parent-height inherit-parent-width"
                  src={
                    props.faceComparisonData?.fileUrl ||
                    `data:image/png;base64,${props.faceComparisonData?.captured?.photo}`
                  }
                  alt="capturedImage"
                />
              ) : (
                <div className="inherit-parent-width inherit-parent-height">
                  <div className="shimmer padding-larger inherit-parent-width inherit-parent-height" />
                </div>
              )}
            </div>
          </div>

          <div className="font-size-small text-align-center">
            MATCHED IMAGE
            <div
              style={{
                width: "156px",
                height: "182px"
              }}
            >
              {props.faceComparisonData?.reference?.[0]?.fileUrl ||
              props.faceComparisonData?.matched?.photo ? (
                <img
                  style={{
                    objectFit: "cover"
                  }}
                  className="inherit-parent-height inherit-parent-width"
                  src={
                    props.faceComparisonData?.reference?.[0]?.fileUrl ||
                    `data:image/png;base64,${props.faceComparisonData?.matched?.photo}`
                  }
                  alt="capturedImage"
                />
              ) : (
                <div className="inherit-parent-width inherit-parent-height">
                  <div className="shimmer padding-larger inherit-parent-width inherit-parent-height" />
                </div>
              )}
            </div>
          </div>
        </div>

        <div className="padding-top-default text-align-center font-size-small">
          <Fields
            title="EMPLOYEE"
            data={
              props.faceComparisonData?.employee?.name ||
              props.faceComparisonData?.matched?.employee?.name ||
              "N/A"
            }
          />
          <Fields
            title="TIME"
            data={`${dateAndTimeConverter(
              props.faceComparisonData?.createdAt ||
                props.faceComparisonData?.capturedAt,
              "secondDate"
            )},
          ${dateAndTimeConverter(
            props.faceComparisonData?.createdAt ||
              props.faceComparisonData?.capturedAt,
            "Time"
          )}`}
          />
          <Fields
            title="LOCATIONS"
            data={` ${
              props.faceComparisonData?.location?.PCTNo || props.location?.PCTNo
            } - ${
              props.faceComparisonData?.location?.address ||
              props.location?.location
            }`}
          />
        </div>
      </div>
      {props.type !== "notInLocation" && (
        <>
          <div className="flex-align-items-center flex-justify-content-center font-size-small white-space-nowrap">
            Not you or someone you're verifying?&nbsp;
            <span
              onClick={() => {
                props.navigate(
                  "/faceIdentification/employeeSearch?type=notMatch"
                );
              }}
              className="font-color-secondaryColor cursor-pointer"
            >
              Request verification.
            </span>
          </div>

          <div className="flex-center-children-vertically padding-top-default padding-bottom-default">
            <hr
              style={{ width: "100%" }}
              className="display-inline-block border-color-secondary-lite border-top-left-right-none flex-basis-1"
            />
            <span className="margin-horizontal-default display-inline-block font-color-secondary font-size-small">
              OR
            </span>
            <hr
              style={{ width: "100%" }}
              className="display-inline-block border-color-secondary-lite border-top-left-right-none flex-basis-1"
            />
          </div>
        </>
      )}
      <Button
        data-cy="okay-button"
        type="button"
        text="Okay"
        boxShadow={false}
        onClick={() => {
          props.navigate("/faceIdentification/lastCapturedAttendance");
        }}
      />
    </div>
  );
};

const Failed = (props) => {
  return (
    <div className="inherit-parent-height inherit-parent-width padding-large display-flex flex-direction-column flex-justify-content-space-between">
      <div
        style={{ height: "calc(100% - 68px)" }}
        className="display-flex flex-direction-column flex-align-items-center flex-justify-content-center"
      >
        <div
          style={{
            width: "56px",
            height: "56px"
          }}
          className="margin-bottom-larger"
        >
          <WarningIcon width="56" height="56" color="#FF4C4C" />
        </div>

        <div className="font-size-medium  text-align-center ">
          NO MATCHES FOUND
        </div>
        <div className="font-size-small text-align-center padding-top-small ">
          No reference user found for the captured face
        </div>

        <div className="padding-top-larger">
          <div
            style={{
              width: "156px",
              height: "182px",
              border: "solid 2px red",
              borderRadius: "4px"
            }}
          >
            {props.faceComparisonData?.fileUrl || props.capturedPhoto ? (
              <img
                style={{
                  objectFit: "cover"
                }}
                className="inherit-parent-height inherit-parent-width"
                src={props.faceComparisonData?.fileUrl || props.capturedPhoto}
                alt="capturedImage"
              />
            ) : (
              <div className="inherit-parent-width inherit-parent-height">
                <div className="shimmer padding-larger inherit-parent-width inherit-parent-height" />
              </div>
            )}
          </div>
        </div>

        <div className="padding-top-larger text-align-center font-size-small">
          <Fields
            title="TIME"
            data={`
              ${dateAndTimeConverter(
                parseInt(
                  props.faceComparisonData?.body?.createdAt ||
                    props.faceComparisonData?.createdAt
                ),
                "secondDate"
              )},
              ${dateAndTimeConverter(
                parseInt(
                  props.faceComparisonData?.body?.createdAt ||
                    props.faceComparisonData?.createdAt
                ),
                "Time"
              )}`}
          />
          <Fields
            title="LOCATIONS"
            data={`${
              props.faceComparisonData?.location?.PCTNo || props.location?.PCTNo
            } - ${
              props.faceComparisonData?.location?.address ||
              props.location?.location
            }`}
          />
        </div>
      </div>

      <div className="font-size-small text-align-center">
        <span
          className="font-color-secondaryColor"
          onClick={() => {
            props.navigate("/faceIdentification/employeeSearch");
          }}
        >
          Submit{" "}
        </span>
        for manual approval
      </div>
      {!props.faceComparisonData?.fileUrl && (
        <>
          <div className="padding-vertical-medium display-flex flex-justify-content-center flex-align-items-center">
            <div
              style={{
                width: "100%",
                border: "1px solid #F2F2F2"
              }}
            />
            <div className="font-size-small padding-horizontal-default">OR</div>
            <div
              style={{
                width: "100%",
                border: "1px solid #F2F2F2"
              }}
            />
          </div>
          <Button
            data-cy="Retake-button"
            type="button"
            text="Retake"
            boxShadow={false}
            onClick={() => {
              props.buttonOnClick();
            }}
          />
        </>
      )}
    </div>
  );
};

const Offline = (props) => {
  return (
    <div className="inherit-parent-height inherit-parent-width padding-large display-flex flex-direction-column flex-justify-content-space-between">
      <div
        style={{ height: "calc(100% - 68px)" }}
        className="display-flex flex-direction-column flex-align-items-center flex-justify-content-center"
      >
        <div
          style={{
            width: "56px",
            height: "56px"
          }}
          className="margin-bottom-larger"
        >
          <OfflineIcon />
        </div>
        <div className="font-size-medium  text-align-center ">
          YOUR ARE OFFLINE
        </div>
        <div className="font-size-small text-align-center padding-top-small font-color-tertiaryColor5">
          WAITING FOR NETWORK CONNECTION
        </div>

        <div className="padding-top-larger">
          <div
            style={{
              width: "156px",
              height: "182px",
              border: "solid 2px #FF9D35",
              borderRadius: "4px"
            }}
          >
            {props.faceComparisonData?.body?.previewPhoto ? (
              <img
                style={{
                  objectFit: "cover"
                }}
                className="inherit-parent-height inherit-parent-width"
                src={props.faceComparisonData?.body?.previewPhoto}
                alt="capturedImage"
              />
            ) : (
              <div className="inherit-parent-width inherit-parent-height">
                <div className="shimmer padding-larger inherit-parent-width inherit-parent-height" />
              </div>
            )}
          </div>
        </div>

        <div className="padding-top-larger text-align-center font-size-small">
          <Fields
            title="TIME"
            data={`
              ${dateAndTimeConverter(
                parseInt(props.faceComparisonData?.body?.createdAt),
                "secondDate"
              )},
              ${dateAndTimeConverter(
                parseInt(props.faceComparisonData?.body?.createdAt),
                "Time"
              )}`}
          />
          <Fields
            title="LOCATIONS"
            data={`${props.faceComparisonData?.body?.PCTNo} - ${props.faceComparisonData?.body?.address}`}
          />
        </div>
      </div>
      <Button
        data-cy="continue-to-home-button"
        type="button"
        text="Okay"
        boxShadow={false}
        onClick={() => {
          props.navigate("/faceIdentification/lastCapturedAttendance");
        }}
      />
    </div>
  );
};

const PendingApproval = (props) => {
  return (
    <div className="inherit-parent-height inherit-parent-width padding-large display-flex flex-direction-column flex-justify-content-space-between">
      <div
        style={{ height: "calc(100% - 68px)" }}
        className="display-flex flex-direction-column flex-align-items-center flex-justify-content-center"
      >
        <div
          style={{
            width: "56px",
            height: "56px"
          }}
          className="margin-bottom-larger"
        >
          <ApprovalPendingIcon />
        </div>
        <div className="font-size-medium  text-align-center ">
          MANUAL APPROVAL PENDING
        </div>
        <div className="font-size-small text-align-center padding-top-small font-color-tertiaryColor5">
          {props.type === "notInLocation"
            ? "Your location will be verified on admin approval."
            : "Your reference image will be verified on admin approval."}
        </div>

        <div className="padding-top-larger">
          <div
            style={{
              width: "156px",
              height: "182px",
              border: "solid 2px #FF9D35",
              borderRadius: "4px"
            }}
          >
            {props.faceComparisonData?.fileUrl ||
            props.faceComparisonData?.captured?.photo ? (
              <img
                style={{
                  objectFit: "cover"
                }}
                className="inherit-parent-height inherit-parent-width"
                src={
                  props.faceComparisonData?.fileUrl ||
                  `data:image/png;base64,${props.faceComparisonData?.captured?.photo}`
                }
                alt="capturedImage"
              />
            ) : (
              <div className="inherit-parent-width inherit-parent-height">
                <div className="shimmer padding-larger inherit-parent-width inherit-parent-height" />
              </div>
            )}
          </div>
        </div>

        <div className="padding-top-larger text-align-center font-size-medium">
          {props.faceComparisonData?.employee?.name ||
            props.faceComparisonData?.matched?.employee?.name ||
            "N/A"}
        </div>

        <div className="padding-top-larger text-align-center font-size-small">
          Captured in
          <span className="">{` ${
            props.faceComparisonData?.location?.PCTNo || props.location?.PCTNo
          } - ${
            props.faceComparisonData?.location?.address ||
            props.location?.location
          }`}</span>{" "}
          on{" "}
          {`${dateAndTimeConverter(
            props.faceComparisonData?.createdAt ||
              props.faceComparisonData?.capturedAt,
            "secondDate"
          )}`}
          ,
          <span className="">{` ${dateAndTimeConverter(
            props.faceComparisonData?.createdAt ||
              props.faceComparisonData?.capturedAt,
            "Time"
          )} `}</span>
        </div>
      </div>
      <Button
        data-cy="continue-to-home-button"
        type="button"
        text="Okay"
        boxShadow={false}
        onClick={() => {
          props.navigate("/faceIdentification/lastCapturedAttendance");
        }}
      />
    </div>
  );
};

const ApprovalDenied = (props) => {
  return (
    <div className="inherit-parent-height inherit-parent-width padding-large display-flex flex-direction-column flex-justify-content-space-between">
      <div
        style={{ height: "calc(100% - 68px)" }}
        className="display-flex flex-direction-column flex-align-items-center flex-justify-content-center"
      >
        <div
          style={{
            width: "56px",
            height: "56px"
          }}
          className="margin-bottom-larger"
        >
          <WarningIcon width="56" height="56" color="#FF4C4C" />
        </div>

        <div className="font-size-medium  text-align-center ">
          MANUAL APPROVAL DENIED
        </div>
        <div className="font-size-small text-align-center padding-top-small ">
          Admin rejected the image or location.
        </div>

        <div className="padding-top-larger">
          <div
            style={{
              width: "156px",
              height: "182px",
              border: "solid 2px red",
              borderRadius: "4px"
            }}
          >
            {props.faceComparisonData?.fileUrl || props.capturedPhoto ? (
              <img
                style={{
                  objectFit: "cover"
                }}
                className="inherit-parent-height inherit-parent-width"
                src={props.faceComparisonData?.fileUrl || props.capturedPhoto}
                alt="capturedImage"
              />
            ) : (
              <div className="inherit-parent-width inherit-parent-height">
                <div className="shimmer padding-larger inherit-parent-width inherit-parent-height" />
              </div>
            )}
          </div>
        </div>

        <div className="padding-top-larger text-align-center font-size-medium ">
          {props.faceComparisonData?.employee?.name ||
            props.faceComparisonData?.matched?.employee?.name ||
            "N/A"}
        </div>

        <div className="padding-top-larger text-align-center font-size-small">
          Captured in
          <span className="">{` ${
            props.faceComparisonData?.location?.PCTNo || props.location?.PCTNo
          } - ${
            props.faceComparisonData?.location?.address ||
            props.location?.location
          }`}</span>
          {""}
          on{""}
          {`${dateAndTimeConverter(
            props.faceComparisonData?.createdAt || +new Date(),
            "secondDate"
          )}`}
          ,
          <span className="">{` ${dateAndTimeConverter(
            props.faceComparisonData?.createdAt || +new Date(),
            "Time"
          )} `}</span>
        </div>
      </div>

      <Button
        data-cy="continue-to-home-button"
        type="button"
        text="Okay"
        boxShadow={false}
        onClick={() => {
          props.navigate("/faceIdentification/lastCapturedAttendance");
        }}
      />
    </div>
  );
};

export const Fields = (props) => {
  return (
    <div className="display-flex padding-top-large">
      <div className="display-flex">
        <div
          className="white-space-no-wrap font-color-tertiaryColor6"
          style={{ width: "180px", textAlign: "left" }}
          data-cy={`${props.title}`}
        >
          {props.title}
        </div>
      </div>
      <div
        className={`text-align-left inherit-parent-width text-overflow-ellipsis font-color-tertiaryColor ${
          !props.removeCapitalize && "text-capitalize"
        }`}
        data-cy={props.dataCy || props.data}
        style={{
          textWrap: "wrap"
        }}
      >
        {props.data}
      </div>
    </div>
  );
};
